import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as actions from "../../actions/acBookingFlow"
import { BookingFlowStep } from "../../actions/acBookingFlow"

import leftArrow from '../../static/img/ic-arrow-left.png'
import rightArrow from '../../static/img/ic-arrow-right.png'
import moment from "moment"

class TimeSlotSeeker extends Component {

	constructor(props) {
		super(props)

		this.state = {}
	}

	componentWillReceiveProps(nextProps) {
		if ((this.props.currentStep !== BookingFlowStep.AVAILABILITIES && nextProps.currentStep === BookingFlowStep.AVAILABILITIES) || (nextProps.currentStep === BookingFlowStep.AVAILABILITIES && (this.props.duration !== nextProps.duration || this.props.frequency !== nextProps.frequency))) {
			this.setState({ selectedDay: undefined })
			this.props.dispatch(actions.bookingFlowDataChange({ selectedHourTimeSlots: undefined, selectedTimeSlot: undefined }))
			this.props.dispatch(actions.bookingFlowFetchTimeSlots(this.props.currentTimeSlotWeek))
		}
	}

	render() {
		let { t } = this.context

		return (
			<div className="TimeSlotSeeker">
				<div className="current-month">
					<div className="line"/>
					{this.renderCurrentMonth()}
					<div className="line"/>
				</div>

				<div className="date-selection">

					<div className="button" onClick={this.onPreviousWeekClick}><img className="arrow" alt="" src={leftArrow}/></div>

					{this.renderDays()}

					<div className="button" onClick={this.onNextWeekClick}><img className="arrow" alt="" src={rightArrow}/></div>
				</div>

				<div className={"hour-selection" + (this.state.selectedDay ? " visible" : "")}>

					<div className="title">{t('time_slot_seeker_choose_hour')}</div>

					{this.renderHours()}

				</div>
			</div>
		)
	}

	renderCurrentMonth = () => {
		let firstDayOfWeek = moment(this.props.currentTimeSlotWeek)
		let lastDayOfWeek = moment(this.props.currentTimeSlotWeek).add(7, 'days')

		let firstDayMonth = firstDayOfWeek.format('MMM')
		let lastDayMonth = lastDayOfWeek.format('MMM')

		let label
		if (firstDayMonth === lastDayMonth) {
			label = firstDayMonth + '. ' + firstDayOfWeek.format('YYYY')
		} else {
			let firstDayYear = firstDayOfWeek.format('YYYY')
			let lastDayYear = lastDayOfWeek.format('YYYY')

			if (firstDayYear === lastDayYear) {
				label = firstDayMonth + '. - ' + lastDayMonth + '. ' + lastDayYear
			} else {
				label = firstDayMonth + '. ' + firstDayYear + ' - ' + lastDayMonth + '. ' + lastDayYear
			}
		}

		return (
			<div className="title">{label}</div>
		)
	}

	renderDays = () => {
		let days = []
		for (let i = 0; i < 7; i++) {
			let day = moment(this.props.currentTimeSlotWeek).add(i, 'days')
			days.push(this.renderDay(i, day))
		}

		return (
			<div className="days">
				{days}
			</div>
		)
	}

	renderDay = (key, day) => {
		let isSelected = this.isDaySelected(day)
		let isAvailable = this.isDayAvailable(day)

		let className = 'day'
		if (isSelected) {
			className += ' selected'
		} else if (isAvailable) {
			className += ' available'
		}

		return (
			<div className={className} onClick={() => isAvailable ? this.onDaySelected(day) : {}} key={key}>

				<div className="number">{day.format('DD')}</div>
				<div className="name">{day.format('ddd')}.</div>

			</div>
		)
	}

	renderHours = () => {
		let startHour = moment().startOf('day').add(6, 'hours')

		return (
			<div className="hours">
				{this.renderHoursLine(moment(startHour))}
				{this.renderHoursLine(moment(startHour).add(4, 'hours'))}
				{this.renderHoursLine(moment(startHour).add(8, 'hours'))}
			</div>
		)
	}

	renderHoursLine = (currentHour) => {
		let hours = []
		for (let i = 0; i < 8; i++) {
			hours.push(this.renderHour(moment(currentHour)))
			currentHour.add(30, 'minutes')
		}

		return (
			<div className="line">{hours}</div>
		)
	}

	renderHour = (hour) => {
		let formatted = hour.format('HH:mm')
		let isSelected = this.isHourSelected(hour)
		let isAvailable = this.isHourAvailable(hour)

		let className = 'hour'
		if (isSelected) {
			className += ' selected'
		} else if (isAvailable) {
			className += ' available'
		}

		return (
			<div className={className} key={formatted} onClick={() => isAvailable ? this.onHourSelected(hour) : {}}>{formatted}</div>
		)
	}

	isDayAvailable = (day) => {
		return day.format('YYYY-MM-DD') in this.props.timeSlots
	}

	isDaySelected = (day) => {
		if (!this.state.selectedDay) {
			return false
		}

		let selectedDay = this.state.selectedDay.format('YYYY-MM-DD')
		return selectedDay === day.format('YYYY-MM-DD')
	}

	isHourAvailable = (hour) => {
		if (!this.state.selectedDay) {
			return false
		}

		let hourTimeSlots = this.findHourTimeSlots(this.state.selectedDay, hour)
		return hourTimeSlots !== undefined
	}

	isHourSelected = (hour) => {
		if (!this.props.selectedHourTimeSlots || this.props.selectedHourTimeSlots.length < 1) {
			return false
		}

		let firstSelectedTimeSlotStartTime = this.props.selectedHourTimeSlots[0].startTime
		return moment(firstSelectedTimeSlotStartTime).format('HH:mm') === hour.format('HH:mm')
	}

	onDaySelected = (day) => {
		this.props.dispatch(actions.bookingFlowDataChange({ selectedTimeSlot: undefined, selectedHourTimeSlots: undefined }))
		this.setState({ selectedDay: day })
	}

	onHourSelected = (hour) => {
		if (this.state.selectedDay) {
			let hourTimeSlots = this.findHourTimeSlots(this.state.selectedDay, hour)
			if (hourTimeSlots) {
				this.props.dispatch(actions.bookingFlowDataChange({
					selectedHourTimeSlots: hourTimeSlots,
					selectedTimeSlot: hourTimeSlots[0]
				}))
			}
		}
	}

	findHourTimeSlots = (day, hour) => {
		let timeSlots = this.props.timeSlots[day.format('YYYY-MM-DD')]
		if (!timeSlots) {
			return undefined
		}

		let formattedHour = hour.format('HH:mm')
		return timeSlots[formattedHour]
	}

	onPreviousWeekClick = () => {
		let newWeek = this.props.currentTimeSlotWeek.subtract(1, 'weeks')
		this.props.dispatch(actions.bookingFlowMetaChange({ currentTimeSlotWeek: newWeek }))
		this.props.dispatch(actions.bookingFlowFetchTimeSlots(newWeek))
	}

	onNextWeekClick = () => {
		let newWeek = this.props.currentTimeSlotWeek.add(1, 'weeks')
		this.props.dispatch(actions.bookingFlowMetaChange({ currentTimeSlotWeek: newWeek }))
		this.props.dispatch(actions.bookingFlowFetchTimeSlots(newWeek))
	}
}

TimeSlotSeeker.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	currentStep: state.metadataReducer.bookingFlow.currentStep,
	currentTimeSlotWeek: state.metadataReducer.bookingFlow.currentTimeSlotWeek,
	duration: state.dataReducer.bookingFlow.duration,
	frequency: state.dataReducer.bookingFlow.frequency,
	selectedWorkerLanguage: state.dataReducer.bookingFlow.selectedWorkerLanguage,
	selectedAffiliate: state.dataReducer.bookingFlow.selectedAffiliate,
	selectedWorker: state.dataReducer.bookingFlow.selectedWorker,
	workerSodexoNumber: state.dataReducer.bookingFlow.workerSodexoNumber,
	timeSlots: state.dataReducer.bookingFlow.timeSlots,
	selectedHourTimeSlots: state.dataReducer.bookingFlow.selectedHourTimeSlots

})
export default connect(mapStateToProps)(TimeSlotSeeker);


// WEBPACK FOOTER //
// ./src/components/bookingflow/TimeSlotSeeker.js